import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
	getRetireApplication,
	patchRetireApplication,
} from 'stash/actions/api/investorApplication';
import { trackEvent } from 'stash/actions';

import SignUpInvestorProfileQuestion from '../SignUpInvestorProfileQuestion';

const mapStateToProps = (state, ownProps) => {
	const retire_questions =
		state.entities.investor_application.retire_questions || [];
	const filingOptions = retire_questions.find((q) => q.key === 'filing_status');

	return {
		answerOptions: filingOptions ? filingOptions.answers : [],
		filing_status: state.entities.investor_application.filing_status,
		isRetireAddOn: /retire-add-on/.test(ownProps.location.pathname),
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	trackRetireAddOn: () => {
		dispatch(
			trackEvent('RetireAddOn', {
				ScreenName: 'TaxFilingStatus',
			})
		);
	},
	getRetireApplication: () => {
		return dispatch(getRetireApplication());
	},
});

export class SignUpTaxIncomeStatus extends React.Component {
	componentDidMount() {
		const {
			getRetireApplication,
			isRetireAddOn,
			trackRetireAddOn,
		} = this.props;

		getRetireApplication();
		if (isRetireAddOn) {
			trackRetireAddOn();
		}
	}

	render() {
		const {
			completeStep,
			answerOptions,
			filing_status,
			isRetireAddOn,
		} = this.props;

		return (
			<SignUpInvestorProfileQuestion
				className="e2e-signUp-retireTax"
				title="How do you file your taxes?"
				subtitle={`When you report your income to the IRS during tax season, you have
					to select one of the following. We use your tax filing status to
					help determine what type of ${isRetireAddOn ? 'retirement' : ''}
					account is right for you.`}
				questionKey="filing_status"
				answer={filing_status}
				answerOptions={answerOptions}
				completeStep={completeStep}
				patchHandler={patchRetireApplication}
			/>
		);
	}
}

SignUpTaxIncomeStatus.propTypes = {
	answerOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			title: PropTypes.string,
		})
	),
	filing_status: PropTypes.string,
	completeStep: PropTypes.func,
	patchRetireApplication: PropTypes.func,
	getRetireApplication: PropTypes.func,
	trackRetireAddOn: PropTypes.func,
	isRetireAddOn: PropTypes.bool,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SignUpTaxIncomeStatus);
